import EditNote from './edit-note'

import withRedux from './with-redux'

export default withRedux(EditNote)